import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/global.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

const loadLocalBodyFont = () => {
  const stylesheet = document.createElement('link');
  stylesheet.rel = 'stylesheet';
  stylesheet.href = '/fonts/noto-sans-sc.css';
  document.head.appendChild(stylesheet);
};

window.addEventListener('load', () => window.setTimeout(loadLocalBodyFont, 1500), { once: true });
